var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"oecko-media"}},[(_vm.mediaError)?_c('app-icon',{attrs:{"name":"blurOn","size":"tiny","color":"rgba(0,0,0,.2)"}}):(_vm.media && !_vm.mediaError)?_c('img',{attrs:{"id":"media-img","src":_vm.mediaSrc}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }